import { LitElement, css, html } from '@lit'
import styles from '@nova/styles'

class NovaHero extends LitElement {
  static properties = {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    images: {
      type: Array,
    },
  }

  constructor() {
    super()
    this.images = []
  }

  connectedCallback() {
    super.connectedCallback()
  }

  render() {
    return html`
      <div id="images">
        <sl-carousel pagination loop autoplay>
          ${this.images.map(
            (image) => html`
              <sl-carousel-item>
                <img src=${image.url} />
              </sl-carousel-item>
            `,
          )}
        </sl-carousel>
      </div>
      <div id="content">
        <slot></slot>
      </div>
    `
  }

  static styles = [
    styles.flex,
    css`
      :host {
        display: block;
        width: 100%;
        height: 100%;
        padding: 2rem 0;
      }
      @media (min-width: 768px) {
        :host {
          display: flex;
          padding: 5rem 0;
        }
        #images,
        #content {
          width: 50%;
        }
      }
      #content {
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    `,
  ]
}

customElements.define('nova-hero', NovaHero)
